var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconMenuLogout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon-share-mono"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.1011 12.3423L13.6173 9.82675L6.73157 9.82675C6.51266 9.82675 6.30273 9.73979 6.14794 9.58501C5.99315 9.43022 5.90619 9.22028 5.90619 9.00138C5.90619 8.78247 5.99315 8.57254 6.14794 8.41775C6.30273 8.26296 6.51267 8.176 6.73157 8.176L13.6166 8.176L11.1011 5.65975C11.0241 5.5834 10.963 5.49257 10.9213 5.39249C10.8796 5.2924 10.8581 5.18505 10.8581 5.07663C10.8581 4.9682 10.8796 4.86085 10.9213 4.76077C10.963 4.66069 11.0241 4.56985 11.1011 4.4935C11.1777 4.41685 11.2686 4.35605 11.3688 4.31456C11.4689 4.27308 11.5762 4.25173 11.6846 4.25173C11.7929 4.25173 11.9003 4.27308 12.0004 4.31456C12.1005 4.35605 12.1915 4.41685 12.2681 4.4935L16.1928 8.41825C16.3467 8.57334 16.433 8.78293 16.433 9.00138C16.433 9.21982 16.3467 9.42942 16.1928 9.5845L12.2681 13.5093C12.1115 13.6548 11.9046 13.7339 11.6908 13.7299C11.4771 13.726 11.2733 13.6394 11.1221 13.4882C10.971 13.3371 10.8843 13.1332 10.8804 12.9195C10.8765 12.7058 10.9556 12.4988 11.1011 12.3423Z",
    fill: "#8B95A1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.18956 2.70625C8.18956 3.1615 7.81981 3.53199 7.36456 3.53199L4.20931 3.53199C3.67156 3.53199 3.23431 3.96924 3.23431 4.50624L3.23431 13.495C3.23431 14.0327 3.67156 14.47 4.20931 14.47L7.36531 14.47C7.58411 14.47 7.79395 14.5569 7.94867 14.7116C8.10339 14.8663 8.19031 15.0762 8.19031 15.295C8.19031 15.5138 8.10339 15.7236 7.94867 15.8784C7.79395 16.0331 7.58411 16.12 7.36531 16.12L4.20931 16.12C2.76181 16.12 1.58431 14.9425 1.58431 13.495L1.58431 4.50624C1.58431 3.05949 2.76181 1.88124 4.20931 1.88124L7.36531 1.88124C7.58411 1.88124 7.79395 1.96816 7.94867 2.12288C8.10339 2.2776 8.19031 2.48744 8.19031 2.70625",
    fill: "#8B95A1"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMenuLogout);
export default __webpack_public_path__ + "static/media/icon_menu_logout.2448d5bba9c9b6e72bd01c8a785b4bcb.svg";
export { ForwardRef as ReactComponent };